"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheVisionaries() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="222843" id="the-visionaries" className="bg-background text-foreground py-24 md:py-32 overflow-hidden" ref={sectionRef}>
      <div className="container mx-auto px-6 md:px-12 lg:px-24 max-w-7xl">
        <div className={`grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="relative w-full aspect-[4/5] lg:aspect-auto lg:h-[700px] rounded-lg overflow-hidden shadow-xl">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687098/img/event_planners_portrait.png" alt="Signature Occasions Founders" className="absolute inset-0 w-full h-full object-cover" />
            {}
            <div className="absolute inset-0 bg-primary/10 mix-blend-multiply pointer-events-none"></div>
          </div>

          {}
          <div className="flex flex-col justify-center">
            <span className="text-sm font-default font-medium tracking-widest uppercase text-primary mb-6">
              The Visionaries
            </span>
            
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light text-foreground mb-8 leading-tight tracking-tight">
              The Art of the Atmosphere
            </h2>
            
            <div className="space-y-6 text-lg text-muted-foreground leading-relaxed font-default font-light tracking-wide">
              <p>
                At Signature Occasions, we believe that every celebration is a living canvas. Our journey began with a shared passion for transforming ordinary spaces into ethereal experiences that linger in the memory long after the final toast.
              </p>
              <p>
                We curate more than just events; we design moments of pure connection. By blending moonlit lavender palettes with silver-dust accents, we ensure that every wedding and corporate gala reflects the unique soul of our clients with sophisticated grace.
              </p>
              <p>
                Our vision is to redefine luxury through meticulous planning and an unwavering commitment to aesthetic excellence, crafting bespoke atmospheres where every detail is a signature of your personal style.
              </p>
            </div>

            <div className="mt-12 pt-8 border-t border-secondary">
              <div className="text-3xl md:text-4xl font-serif italic text-primary">
                Julianne & Marcella
              </div>
              <div className="text-sm text-muted-foreground mt-2 font-default tracking-widest uppercase">
                Founding Partners & Creative Directors
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}